import React from 'react';

const StorybookIcon = () => {
  return <img src='/skill-icons/storybook.png' alt='storybook-logo' />;
};

export default StorybookIcon;
